import { render, staticRenderFns } from "./DistributionListCreate.vue?vue&type=template&id=c64cf4da&scoped=true&"
import script from "./DistributionListCreate.vue?vue&type=script&lang=js&"
export * from "./DistributionListCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64cf4da",
  null
  
)

export default component.exports